import { DefaultTeamLogo } from '@capsicum/common';
import { Image } from '@capsicum/common-web';
import { type V2MigrationFanTokenLogoCommonProps } from '@capsicum/features/nc-wallet/shared';
import { type ComponentProps, useState } from 'react';
import styled from 'styled-components';

type V2MigrationFanTokenLogoProps = V2MigrationFanTokenLogoCommonProps &
	Pick<ComponentProps<typeof Image>, 'className'>;

export const V2MigrationFanTokenLogo = ({ className, logo, name, shortCode, size }: V2MigrationFanTokenLogoProps) => {
	const [isError, setError] = useState(false);

	const showDefaultLogo = !logo || isError;

	return (
		<S.StyledImage
			alt={`${name} Logo`}
			blurhash={showDefaultLogo ? undefined : logo.blurHash}
			className={className}
			data-testid={`fanTokenBreakdownCard-${shortCode}-logo`}
			height={size}
			src={showDefaultLogo ? DefaultTeamLogo : logo.url}
			width={size}
			onError={() => setError(true)}
		/>
	);
};

namespace S {
	export const StyledImage = styled(Image)`
		${({ theme }) => theme.border.radius.circle};
	`;
}
